import { FC } from "react";

const About: FC = () => {
    return (
        <div className="row pt-4" id="about">
            <div className="col-lg-6">
                <h4>Algemeen</h4>
                <p>
                    Hieronder vind je alle door Sweco gemaakte maatwerk
                    extensies voor de VertiGIS Studio Apps. Klik op de release naam om
                    de 'latest' readme te openen.
                </p>
                <p>
                    Voor meer informatie over GeoWeb en extensies, zie ook{" "}
                    <a href="https://geoweb.software/">
                        https://geoweb.software/
                    </a>
                    .
                </p>
            </div>
            <div className="col-lg-6">
                <h4>Licentieserver</h4>
                <p>
                    Sommige extensies zijn beveiligd door onze licentieserver en
                    moeten eerst vrijgegeven worden; maak hiervoor een product
                    id en een api-key in de{" "}
                    <a href="https://entitle.geowebonline.nl/licenseserver">
                        licentieserver
                    </a>
                    .
                </p>
            </div>
        </div>
    );
};

export default About;
